import React, {useState} from "react";
import {useSelector} from "react-redux";
import LoadingIndicator from "../../LoadingIndicator";
import moment from "moment";
import {Paper, Tab} from "@material-ui/core";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import MobileUserAccountPaymentDemandsList from "./MobileUserAccountPaymentDemandsList";

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const MobileUserAccountPaymentDemands = () => {

  const [activeTab, setActiveTab] = useState('0');
  const {fetching, data: account} = useSelector(state => state.mobileUserAccountDetails)

  return (
    <div style={{padding: 16}}>
      <LoadingIndicator fetching={fetching}>
        {account && account.paymentDemand === null &&
          <div style={{textAlign: 'center', fontSize: 18}}>Wobec użytkownika nie przeprowadzono procesu
            windykacji</div>}
        {account && account.paymentDemand && <React.Fragment>
          <Paper style={{padding: 16}}>
            <div style={{display: 'flex', gap: 10, flexDirection: 'column'}}>
              <div>
                Data wystąpienia
                zadłużenia: {account.paymentDemand.overdraftDate ? moment(account.paymentDemand.overdraftDate).local().format('DD.MM.YYYY HH:mm') : "Brak"}
              </div>
              <div>
                Ostatnie wysłanie wezwania do zapłaty
                SMS: {account.paymentDemand.lastSMSDemandSentAt ? moment(account.paymentDemand.lastSMSDemandSentAt).local().format('DD.MM.YYYY HH:mm') : "Brak"}
              </div>
              <div>
                Ostatnie wysłanie wezwania do zapłaty
                Email: {account.paymentDemand.lastDemandNotificationSentAt ? moment(account.paymentDemand.lastDemandNotificationSentAt).local().format('DD.MM.YYYY HH:mm') : "Brak"}
              </div>
              <div>
                Ostatnie wysłanie powiadomienia
                Email: {account.paymentDemand.lastWarningNotificationSentAt ? moment(account.paymentDemand.lastWarningNotificationSentAt).local().format('DD.MM.YYYY HH:mm') : "Brak"}
              </div>
            </div>
          </Paper>
          <div style={{marginTop: 25}}>
            <TabContext value={activeTab}>
              <div>
                <TabList onChange={(_, value) => (setActiveTab(value))}>
                  <Tab value={'0'} label="Wezwania Email" {...a11yProps(0)} />
                  <Tab value={'1'} label="Wezwania SMS" {...a11yProps(1)} />
                </TabList>
              </div>

              <TabPanel value={'0'} index={'0'} style={{padding: 0}}>
                <MobileUserAccountPaymentDemandsList
                  notifications={account.paymentDemand?.paymentDemandNotifications?.emailNotifications ?? []}
                />
              </TabPanel>
              <TabPanel value={'1'} index={'1'} style={{padding: 0}}>
                <MobileUserAccountPaymentDemandsList
                  notifications={account.paymentDemand?.paymentDemandNotifications?.smsNotifications ?? []}
                />
              </TabPanel>
            </TabContext>
          </div>
        </React.Fragment>
        }
      </LoadingIndicator>
    </div>
  )
}

export default MobileUserAccountPaymentDemands
